import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Mission } from "@/components/Mission";
import { Services } from "@/components/Services";
import { Confort } from "@/components/Confort";
import { Payment } from "@/components/Payment";
import { Satisfaction } from "@/components/Satisfaction";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { FloatingButtons } from "@/components/FloatingButtons";

function App() {
    return (
        <div
            className="font-sans text-neutral-800 bg-[#f8f9fa] antialiased overflow-x-hidden"
            data-testid="landing-page"
        >
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <Mission />
                <Services />
                <Confort />
                <Payment />
                <Satisfaction />
                <Contact />
            </main>
            <Footer />
            <FloatingButtons />
        </div>
    );
}

export default App;
